<script>
export default {
  props: {
    gridOptions: {
      type: Object,
      default: () => {},
    },
    columnDefs: {
      type: Array,
      required: true,
    },
    rowData: {
      type: Array,
      required: true,
    },
    gridSize: {
      type: [String, Number],
      default: 'lg',
      validator: val =>
        typeof val === 'string'
          ? ['auto', 'lg', 'md', 'sm', 'max'].includes(val)
          : typeof val === 'number',
    },
    groupDefaultExpanded: {
      // 0 for none, 1 for first level only, etc. Set to -1 to expand everything.
      type: Number,
      default: 0,
    },
    masterDetail: {
      type: Boolean,
      default: false,
    },
    detailCellRendererParams: {
      type: Object,
      default: undefined,
    },
    getRowHeight: {
      type: Function,
      default: undefined,
    },
  },
}
</script>
